<div class="default-page-root">

  <router-outlet></router-outlet>
  
</div>
